export enum SchoolTypes {
  All = 0,
  ElementarySchool = 1,
  MiddleSchool = 2,
  HighSchool = 3,
  PreSchool = 4,
}

export function getSchoolTypeName(value: SchoolTypes): string {
  switch (value) {
    case SchoolTypes.All: return 'すべて';
    case SchoolTypes.ElementarySchool: return '小学校';
    case SchoolTypes.MiddleSchool: return '中学校';
    case SchoolTypes.HighSchool: return '高校';
    case SchoolTypes.PreSchool: return '幼稚園・保育園';
  }
}

export function getSchoolTypeItems(isAll: boolean) {
  const items = new Array();
  for (const item in SchoolTypes) {
    if (!isNaN(Number(item))) {
      const num = Number(item);
      if (isAll || num !== SchoolTypes.All) {
        items.push({
          id: num,
          name: getSchoolTypeName(num)
        });
      }
    }
  }
  return items;
}

export function getTestSchoolTypeItems(isAll: boolean) {
  return getSchoolTypeItems(isAll).filter((num) => {
    switch (num.id) {
      case SchoolTypes.All:
      case SchoolTypes.ElementarySchool:
      case SchoolTypes.MiddleSchool:
      case SchoolTypes.HighSchool:
        return true;
      default:
        return false;
    }
  });
}
